import { render } from "./UploadDocumentsIndividual.vue?vue&type=template&id=345a8d66"
import script from "./UploadDocumentsIndividual.vue?vue&type=script&lang=js"
export * from "./UploadDocumentsIndividual.vue?vue&type=script&lang=js"

import "./UploadDocumentsIndividual.vue?vue&type=style&index=0&id=345a8d66&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__